import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["salaryInput", "seekingFirstJobCheckbox"];

  connect() {
    this.form = this.element.closest("form");
    if (!this.form) return;

    this.setupMoneyValidation();
  }

  setupMoneyValidation() {
    this.moneyInputs = this.form.querySelectorAll(".mask-money");
    this.submitBtn = this.form.querySelector('button[type="submit"]') || document.getElementById('form-navigation-btn');

    // Valida na carga da página
    setTimeout(() => this.validateMoneyInputs(), 100);

    // Valida em tempo real ao digitar e interagir
    this.moneyInputs.forEach((input) => {
      input.addEventListener("input", () => this.validateMoneyInputs());
      input.addEventListener("blur", () => this.validateMoneyInputs());
      input.addEventListener("keyup", () => this.validateMoneyInputs());
      input.addEventListener("change", () => this.validateMoneyInputs());
    });

    // Trava de segurança no submit do form (fase de captura)
    this.form.addEventListener("submit", (e) => {
      const isValid = this.validateMoneyInputs();
      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const firstErr = this.form.querySelector(".mask-money.is-invalid");
        if (firstErr) {
          firstErr.focus();
          firstErr.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        if (typeof window.showTopBannerError === "function") {
          window.showTopBannerError("Por favor, preencha os valores informados antes de continuar.");
        }
      }
    }, true);
  }

  isMoneyValueZero(val) {
    if (!val) return true;
    const cleanVal = val.replace(/[^\d]/g, ""); // Remove tudo que não for dígito
    return cleanVal === "" || parseInt(cleanVal, 10) === 0;
  }

  setSubmitState(isValid) {
    if (this.submitBtn) {
      const hasAnyInvalid = this.form.querySelector(".is-invalid") !== null;
      const finalValid = isValid && !hasAnyInvalid;

      this.submitBtn.disabled = !finalValid;
      this.submitBtn.style.cursor = finalValid ? "pointer" : "not-allowed";
      if (!finalValid) {
        this.submitBtn.classList.add("disabled");
      } else {
        this.submitBtn.classList.remove("disabled");
      }
    }
  }

  validateMoneyInputs() {
    let formIsValid = true;

    if (this.moneyInputs) {
      this.moneyInputs.forEach((input) => {
        // Se o input estiver desabilitado (ex: seekingFirstJob ativo), ignora
        if (input.disabled) return;

        if (input.required) {
          const val = input.value.trim();
          if (this.isMoneyValueZero(val)) {
            input.classList.remove("is-valid");
            input.classList.add("is-invalid");
            formIsValid = false;
          } else {
            input.classList.remove("is-invalid");
            input.classList.add("is-valid");
          }
        }
      });
    }

    this.setSubmitState(formIsValid);
    return formIsValid;
  }

  toggleFirstJob() {
    const checked = this.seekingFirstJobCheckboxTarget.checked;

    if (checked) {
      this.salaryInputTarget.value = "";
      this.salaryInputTarget.disabled = true;
      this.salaryInputTarget.classList.remove("is-invalid");
    } else {
      this.salaryInputTarget.disabled = false;
      this.salaryInputTarget.value = "0,00";
    }

    // Atualiza a validação imediatamente após marcar/desmarcar
    this.validateMoneyInputs();
  }
}
